import React from "react";

export const dateConvertor = (inputDate: any) => {
  const date = new Date(inputDate);
  return date.toLocaleString("en-US");
};
